import * as m from 'mithril';

import LocationFilterList from "./LocationFilterList";
import { NavBar } from '../../components/NavBar';
import { MessageProvider } from '../../context/AppMessages';
import AppContext from '../../context/AppContext';
import buildLanguageChangeActions from '../common/LanguageNavActions';
import { LocationDTO } from '../../apiclient/ApiDtos';

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    title: string,
    locations: LocationDTO[],
    isUpdatedSourceLocations: boolean,
    onLocationSelected: (location: LocationDTO) => void,
    onClose: () => void
}

export default function LocationSelectionPage(): m.Component<Attrs> {
    return {
        onupdate(vnode) {
            if(vnode.attrs.isUpdatedSourceLocations){
                m.redraw();
            }
        },
        view(vnode) {
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return [
                m('div', { class: 'app-layout bg'}, [
                    m(NavBar, {
                        title: vnode.attrs.title,
                        canBackPress: true,
                        onBackPressed: () => { vnode.attrs.onClose(); },
                        actionItems: langChangeActionItems
                    }),
                    m("div.app-area-main",
                        m(LocationFilterList, {
                            currentLang: vnode.attrs.messageProvider.getCurrentLang(),
                            isUpdated: vnode.attrs.isUpdatedSourceLocations,
                            locations: vnode.attrs.locations,
                            onLocationSelected: (location: LocationDTO) => {
                                vnode.attrs.onLocationSelected(location);
                            }
                        })
                    )
                ])
                
            ];
        }
    }
}